import { LitElement, html, css } from 'lit';
import { WEB_CONTENT } from '../../../constants/content';

export class ChatLoadingPlaceholder extends LitElement {
  static properties = {
    progress: { type: Number },
    loadingStatus: { type: String },
    containerId: { type: String }
  };

  static styles = css`
    .loading-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: var(--bg-secondary-color);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 1000;
    }
    
    .loading-container.contained {
      z-index: 1000;
    }

  

    .whatsapp-logo {
      margin-bottom: 30px;
    }

    .progress-container {
      width: 250px;
      height: 4px;
      background-color: var(--bg-primary-color);
      border-radius: 2px;
      margin-bottom: 10px;
      overflow: hidden;
    }

    .progress-bar {
      height: 100%;
      background-color: var(--base-color);
      border-radius: 2px;
      transition: width 0.3s ease;
    }

    .progress-text {
      font-size: 14px;
      color: var(--text-outgoing-message);
    }

    .status-text {
      margin-top: 15px;
      font-size: 16px;
      color: var(--text-secondary-color);
    }
  `;

  constructor() {
    super();
    this.progress = 0;
    this.loadingStatus = 'Initializing...';
    this.containerId = '';
  }

  updated(changedProperties) {
    super.updated(changedProperties);
    
    if (changedProperties.has('containerId') && this.containerId) {
      this.positionRelativeToContainer();
    }
  }

  positionRelativeToContainer() {
    const targetContainer = document.getElementById(this.containerId);
    const loadingContainer = this.shadowRoot.querySelector('.loading-container');
    
    if (targetContainer && loadingContainer) {
      const rect = targetContainer.getBoundingClientRect();
      
      loadingContainer.style.position = 'absolute';
      loadingContainer.style.top = `${rect.top}px`;
      loadingContainer.style.left = `${rect.left}px`;
      loadingContainer.style.width = `${rect.width}px`;
      loadingContainer.style.height = `${rect.height}px`;
    }
  }



  render() {
    // Debug: Log current props
    console.log('MainChatPlaceHolder render - containerId:', this.containerId, 'progress:', this.progress, 'loadingStatus:', this.loadingStatus);
    
    const containerClass = this.containerId ? 'loading-container contained' : 'loading-container';
    console.log(containerClass, this.containerId, 'containerid')
    
    if (this.containerId) {
      // When containerId is provided, render the loading overlay inside the target container
      return html`
        <div class="${containerClass}">
          <div class="progress-container">
            <div class="progress-bar" style="width: ${this.progress}%"></div>
          </div>
          <div class="progress-text">${this.progress}%</div>
          <div class="status-text">${WEB_CONTENT.PLACEHOLDER_CONTENT.LOADING}</div>
        </div>
      `;
    } else {
      // When no containerId, render as full screen overlay
      return html`
        <div class="${containerClass}">
          <div class="progress-container">
            <div class="progress-bar" style="width: ${this.progress}%"></div>
          </div>
          <div class="progress-text">${this.progress}%</div>
          <div class="status-text">${WEB_CONTENT.PLACEHOLDER_CONTENT.LOADING}</div>
        </div>
      `;
    }
  }
}

// Define the element
customElements.define('chat-loading-placeholder', ChatLoadingPlaceholder);